import React from 'react';
export default class Component extends React.Component {
  render = () => {
    return (
      <div className='static-page-wrap text-left small'>
        <p>本利用規約（以下、「本規約」といいます。）には、本サービスの提供条件および当社とユーザーとの権利義務関係が定められています。本サービスの申込み・利用に際しては、本規約の全文をお読み頂いたうえで、本規約に同意頂く必要があります。</p>
<h3>第１条（適用）</h3>
<p>１　本規約は、本サービスの提供条件および本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。</p>
<p>２　当社が当社ウェブサイト上で掲載する、または個別に通知する本サービスの仕様、利用方法、注意事項、制限事項、ガイドラインその他の本サービスの利用に関するルール（以下「利用細則」といいます。）は本規約の一部を構成するものとします。</p>
<p>３　本規約の説明と、前項のルールその他の本規約外における本サービスの説明等とが異なる場合は、本規約が優先して適用されるものとします。</p>
<p>４　本サービスの利用にあたり、当社にライセンスを付与している第三者から利用規約が提示される場合があり（以下「ライセンサー規約」といいます。）、ユーザーは本サービス利用契約に加えライセンサー規約についても遵守する必要があります。ライセンサー規約と本サービス利用契約が矛盾抵触する場合、ライセンサー規約が優先するものとします。</p>
<h3>第２条（用語の定義）</h3>
<p>本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。</p>
<p>（１）「当社」とは、株式会社circrew（サークルー）を意味します。</p>
<p>（２）「本サービス」とは、第３条（本件サービスの内容・免責）に規定する当社が「circrew」または「サークルー」の名称で提供するサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。</p>
<p>（３）「ユーザー」とは、第４条（ユーザー利用登録）に基づいて本サービスの利用者としての登録がなされた個人を意味します。</p>
<p>（４）「サークルー」とは、本サービスのマッチング機能等を利用して形成されたグループを意味します。</p>
<p>（５）「ホスト」とは、第５条（ホスト登録）の登録を受けたユーザーを意味します。</p>
<p>（６）「本サービス利用契約」とは、本規約、利用細則その他当社とユーザーの間に適用される本サービスの利用に関する契約の総体を意味します。</p>
<p>（７）「当社ウェブサイト」とは、そのドメインに「circrew.co.jp」を含む、当社が運営するウェブサイト（理由の如何を問わず、当社のウェブサイトのドメインまたは内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。</p>
<p>（８）「本ソフトウェア」とは、本サービスの利用のために、当社が提供するコンピューター用プログラム、アプリケーションプログラミングインターフェイス（ＡＰＩ）、ＡＰＩ仕様書その他の仕様書およびマニュアルその他の書面を意味します。</p>
<p>（９）「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）を意味します。</p>
<p>（10）「外部サービスプロバイダー」とは、本サービスの提供のために必要な機能等を提供元として当社ウェブサイト記載の事業者を意味します。</p>

<h3>第３条（本サービスの内容・免責）</h3>
<p>１　本サービスは、インターネットを介して同じ趣味・研究その他の活動をしようとする個人をマッチングし、その集まり（サークルー）の設立、管理、会費の徴収等をサポートすることを目的とするものです。</p>
<p>２　当社は、一定のツールの提供等本規約上明示される場合を除きホストを含むユーザーおよびサークルーの活動に関与しません。ユーザーは、他のユーザー、ホストその他サークルーに関する問題につき自ら責任を持ち、解決する必要があることを了承のうえ、本サービスを利用するものとします。</p>
<h3>第４条（ユーザー利用登録）</h3>
<p>１　本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ住所、電話番号、連絡用電子メールアドレス、カード情報（有料サービスを用いる場合）その他当社の定める一定の情報（以下「登録情報」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。</p>
<p>２　当社は、当社の基準に従って、前項に基づいて登録申請を行った登録希望者（以下「登録申請者」といいます。）の登録の可否を判断し、当社が登録を認める場合にはその旨を登録申請者に通知します。登録申請者のユーザーとしての登録は、当社が登録を認める旨の通知を行ったことをもって完了したものとします。</p>
<p>３　前項に定める登録の完了時に、本サービス利用契約がユーザーと当社の間に成立し、ユーザーは本サービスを本サービス利用契約に従い利用することができるようになります。</p>
<p>４　当社は、ユーザーが本サービスのうち有料のサービス（以下「有料サービス」といいます。）の利用を希望する場合、カード情報その他の情報を登録情報として提供することを求めることができるものとします。</p>
<p>５　当社は、当社の基準に従って、前項に基づいて登録申請を行ったユーザーの有料サービスの利用の可否を判断し、利用を認める場合にはその旨をユーザーに通知します。</p>
<p>６　当社は、登録申請者が以下の各号のいずれかの事由に該当する場合は、登録および再登録を拒否することがあり、またその理由について一切開示義務を負いません。</p>
<ul>
<li>（１）当社に提供した登録情報の全部または一部につき虚偽、誤記または記載漏れがあった場合</li>
<li>（２）反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずるものを意味します。以下同じ。）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与を行っていると当社が判断した場合</li>
<li>（３）登録申請者が過去当社との契約に違反した者またはその関係者であると当社が判断した場合</li>
<li>（４）第１６条（登録抹消等）に定める措置を受けたことがある場合</li>
<li>（５）その他、当社が登録を適当でないと判断した場合</li>
</ul>
        <p>７　登録希望者が未成年の場合、必ず事前に法定代理人の同意を得た上で申込をするものとし、申込に際し、未成年者であることおよび法定代理人の同意を得ていることを当社に通知するものとします。</p>
        <h3>第５条（ホスト登録）</h3>
        <p>１　ホストとしてサークルーを立ち上げようとするユーザーは、第４条（ユーザー利用登録）第１項に定める情報に加え、免許証その他の身分証明書、振込先口座その他当社が定める情報を、登録情報として当社の定める方法で当社に提供することにより、当社に対し、ホストとしての登録（以下「ホスト登録」といいます。）を申請することができます。</p>
        <p>２　前項に定めるもののほか、ホストとしての登録手続きは、第４条（ユーザー利用登録）に準じるものとします。</p>
        
        <h3>第６条（サークルーアカウントの開設）</h3>
        <p>１　ホストは、別途当社が定める手続きに従って、ホスト用のアカウント（サークルーアカウント）を開設することがきます。</p>
        <p>２　当社は、ホストに対し、サークルーアカウントにおいて、サービスのメンバーの募集、サークルーの運営、管理、会費の徴収に必要な管理ツールを利用する非独占的かつ譲渡不能な権限を許諾するものとします。</p>
        <p>３　ユーザーは、ホスト登録なしにサークルーを立ち上げることはできないものとします。</p>
        
        <h3>第７条（ホストの責任）</h3>
        <p>１　ホストは、ホスト自身の責任において各サークルーを運営するものとし、サークルーアカウントおよび管理ツール等を利用してなされた一切の行為およびその結果によってユーザー（本条においてホスト以外のユーザーを指すものとします。）、第三者および当社に生じた損害について一切の責任を負うものとします。</p>
        <p>２　ホストは、各サークルーの運営にあたり法令を遵守するとともに、各サークルーを運営する際に必要な活動を、ホスト自身の費用と責任において行うものとします。</p>
        <p>３　ホストは、各サークルーを運営するにあたり、ユーザーに対し、自らがホストであることを明示的に認識させるものとします。</p>
        <p>４　ホストは、各サークルーの運営について、当社が指定する方法によってのみユーザーが利用できるようにするものとします。</p>
        <p>５　ホストは、ユーザーに対して、本サービス上で告知する活動内容を遵守して各サークルーの運営を行うものとします。</p>
        <p>６　ホストは、各サークルーアカウントを運営するにあたり、ユーザーを含む第三者から問い合わせ、クレーム、請求、警告、提訴等（以下「問い合わせ等」といいます。）を受けた場合には、ホスト自身の費用と責任において当該問い合わせ等に対応しなければならないものとし、当社が一切の損失、損害を負担しないよう全て補償することに同意します。また、ホストは、問い合わせ等の内容が、管理ツールの利用または各サークルーアカウントの運営等に関連し、第三者の権利を侵害していることを理由とする場合には、自らの費用および責任においてこれに対応するとともに、速やかに当社に通知するものとします。</p>
        <p>７　当社は、ホストによる各サークルーアカウントの運営に関してユーザーまたは第三者から問い合わせ等を受けた場合には、当該問い合わせ等を行った第三者に対し、当該ホストに連絡するよう要求することができるものとします。この場合、当社は、当該ホストの連絡先を、当該問い合わせ等を行った第三者に開示できるものとし、ホストはあらかじめこれを承諾します。</p>
        <p>８　当社が問い合わせ等を受けたことに起因または関連して当社に損害が生じた場合には、ホストは、当該損害を全て賠償する責を負うものとします。</p>
        <p>９　ホストは、管理ツールまたはサークルーアカウントを利用してユーザーに対して会費その他の金員の徴収等を行う場合、当社に対し、別途当社が定める一定の手数料を支払うものとします。なお、理由のいかんを問わず本規約条明示的に定められている場合を除き、手数料の返還は行われません。</p>
        
        <h3>第８条（登録情報の変更）</h3>
        <p>ユーザーは、登録情報に変更があった場合、当社の定める方法により当該変更を速やかに当社に通知するものとします。</p>
        
        <h3>第９条（通知・連絡）</h3>
        <p>１　当社からユーザーへの通知は、当社ウェブサイトへの掲載、電子メール、書面その他当社が適当と判断する方法により行います。</p>
        <p>２　当社からユーザーへの通知を当社ウェブサイトへの掲載により行う場合は掲載がなされた時点において、電子メールにより行う場合は連絡用電子メール宛に送信が行われた時点において通知がなされたと見なすものとします。</p>
        <p>３　ユーザーは、当社からの電子メールについて、連絡用電子メールアドレスに確実に到達するようにし、当社から依頼があった場合には、当社からの電子メールに対して速やかに応答するものとします。</p>
        <p>４　第１項の通知を書面で行う場合は、登録情報として当社に情報が提供されたユーザーの住所宛に行うものとし、書面が到達した時点において通知がなされたものとします。但し、通知が延着または不到達となった場合は、通常到達すべきときをもって通知が到達したものと見なすものとします。</p>
        <p>５　本サービスに関する問い合わせその他ユーザーから当社に対する連絡または通知は、当社が別途定める方法で行うものとします。</p>
        
        <h3>第１０条（利用環境等）</h3>
        <p>１　ユーザーは、本サービスを利用するために必要な環境（以下「利用環境」といいます。）として当社が指定する環境（本ソフトウェアに含まれるコンピューター用ソフトウェアおよびこれらを利用できるインターネットにブロードバンドで接続が可能なＰＣ・スマート端末を含みますがこれに限られません。）を自らの費用負担と責任で用意するものとします。</p>
        <p>２　ユーザーは、本サービスを利用するＰＣ、スマート端末等がコンピューター・ウイルス、マルウェア等に感染しないようセキュリティソフトのインストール等適切な対策を施すものとし、感染を確認した場合は直ちに当社に連絡をするとともにこれを除去するものとし、併せて当社において適切な対策を取るために、当社が要請する情報を提供するなど協力を行うものとします。</p>
        <p>３　当社は、ユーザーに対し、本サービスを利用するために利用環境の変更を指定することができるものとし、ユーザーは、当社からかかる利用環境の変更の通知を受けた場合には、当該通知に定める期限までに、当該通知に定められた利用環境の変更を自らの費用負担と責任で行うものとします。</p>
        <p>４　当社および当社の指定する第三者は、当社が本サービスに関して保守、運用上または技術上必要であると判断した場合、ユーザーが本サービスにおいて、記録、送信等するデータ等について、監視、分析、調査等必要な行為を行うことができるものとします。</p>
        
        <h3>第１１条（ソフトウェアライセンスとアップデート）</h3>
        <p>１　当社は、当社が本サービスの提供に必要と判断した場合、ユーザーに対し、別途当社が定める条件で、本サービスの利用を目的として本ソフトウェアを使用するための、限定的、非独占的、譲渡禁止、無効化可能なライセンスを付与します。なお、ユーザーは、本ソフトウェアの解析またはデコンパイルをしてはならず、また、当該行為を試みること、第三者が当該行為をなすことに関与してはなりません。</p>
        <p>２　当社は、適宜本ソフトウェアのアップデートを行うことがあります。また、当社はユーザーのＰＣ・スマート端末上の本ソフトウェアを自動的にアップデートすることができるものとします。</p>
        
        <h3>第１２条（パスワードおよびユーザーＩＤの管理）</h3>
        <p>１　ユーザーは、自己の責任において、本サービスに関するパスワードおよびユーザーＩＤを適切に管理および保管するものとし、これを第三者（ユーザーに付与されるパスワードおよびユーザーＩＤについては当該ユーザー以外の者を「第三者」とします。）に利用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。</p>
        <p>２　パスワードまたはユーザーＩＤの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任はユーザーが負うものとし、当社は一切の責任を負いません。</p>
        
        <h3>第１３条（利用料金および支払方法）</h3>
        <p>１　ユーザーは、本サービスの利用の対価として、別途当社が定める利用料金を、当社が指定する方法により当社に支払うものとします。</p>
        <p>２　ユーザーが利用料金の支払を遅滞した場合、ユーザーは１年を３６５日として年１４．６％の割合による遅延損害金を当社に支払うものとします。</p>
        <p>３　当社は、１ヶ月以上の予告期間を設けた通知により第１項の利用料金を変更することができるものとします。変更後の利用料金は当該通知に特に定められている場合を除き、予告期間の満了日の属する月の翌月より適用されるものとします。</p>
        
        <h3>第１４条（禁止事項）</h3>
        <p>ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。</p>
        <p>（１）本ソフトウェアの複製、解析およびデコンパイルまたは第三者によるこれらの行為への関与</p>
        <p>（２）本サービスを通じ、以下に該当しまたは該当すると当社が判断する情報を当社または他の利用者に送信すること</p>
        <ul>
          <li>・コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報</li>
        <li>・当社、本サービスの他の利用者またはその他の第三者のプライバシー、名誉または信用その他法的な利益を毀損する表現を含む情報</li>
        <li>・反社会的な表現や他人に不快感を与える表現を含む情報</li>
          <li>・チェーンメール等の第三者への情報の拡散を求める情報</li>
          </ul>
        <p>（３）当社、外部サービスプロバイダーその他の第三者のネットワークまたはシステム等に不正にアクセスし、または不正なアクセスを試みる行為</p>
        <p>（４）当社、外部サービスプロバイダー、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシー、名誉、その他の権利または利益を侵害する行為</p>
        <p>（５）本サービスのネットワークまたはシステム等に過度な負担をかける行為</p>
        <p>（６）本サービスの運営を妨害するおそれのある行為</p>
        <p>（７）本サービスの他の利用者のＩＤまたはパスワードを利用する行為</p>
        <p>（８）第三者になります行為</p>
        <p>（９）本サービスの他の利用者の情報の収集</p>
        <p>（10）当社、外部サービスプロバイダー、本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為</p>
        <p>（11）宗教活動又は宗教団体への勧誘行為</p>
        <p>（12）当社ウェブサイト上で掲載する本サービス利用に関するルールに抵触する行為</p>
        <p>（13）公序良俗に反する行為</p>
        <p>（14）法令に違反する行為または犯罪に関連する行為</p>
        <p>（15）反社会勢力への利益供与</p>
        <p>（16）前各号の行為を直接または間接に惹起し、または容易にする行為</p>
        <p>（17）ライセンサー規約、外部サービスプロバイダーの適正利用規約その他の外部サービスプロバイダーが定める規約に違反する行為</p>
        <p>（18）その他、当社が不適切と判断する行為</p>
        
        <h3>第１５条（知的財産権・権利帰属）</h3>
        <p>１　当社ウェブサイトおよび本サービスに関する知的財産権は全て当社、外部サービスプロバイダーまたは当社にライセンスを付与している者に帰属しており、本規約に基づく本サービスの利用許諾は、当社ウェブサイトまたは本サービスに関する当社、外部サービスプロバイダーまたは当社にライセンスを付与している者の知的財産権の使用許諾を意味するものではありません。</p>
        <p>２　当社はユーザーからのいかなるフィードバック、要望および提案について、ユーザーの許可無く使用する権限を有します。</p>
        
        <h3>第１６条（バックアップ等）</h3>
        <p>１　ユーザーは、本サービスに係るコンピューター・システム上に保存したデータ（他のユーザーを含む第三者からユーザーに対して送信等されたデータを含むものとし、以下同様とします。）について、自らの責任でバックアップを行うものとし、当社はデータのバックアップ、保管、保存等に関して、一切の責任を負わないものとします。</p>
        <p>２　当社は、本サービスに係るコンピューター・システムまたは本ソフトウェアの点検または保守作業上の必要性等の理由等により、前項のデータを一時的にバックアップする場合があります。なお、かかるバックアップはユーザーの利用のためにデータの保全を行うことを目的とするものではなく、当社はユーザーからバックアップされたデータの提供を求められた場合にこれに応じる義務はなく、またこれに応じる場合でも当社は当該データの正確性、完全性、有用性等につき保証しないものとします。</p>
        
        <h3>第１７条（データの消去）</h3>
        <p>１　本サービスに係るコンピューター・システム上のユーザーのデータ記憶領域に保存されたデータ容量が、当社が別途定める一定の容量を超えた場合、当社はユーザーに事前に通知することなく、容量を超えたデータを消去し、または送受信等を停止することができるものとします。</p>
        <p>２　当社は、前項のデータの消去または送受信等の停止につき、一切の責任を負わないものとします。</p>
        
        <h3>第１８条（本サービスの停止）</h3>
        <p>１　当社は、以下のいずれかに該当する場合には、事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。</p>
        <p>（１）本サービスに係るコンピューター・システムまたは本ソフトウェアの点検または保守作業を緊急に行う必要がある場合</p>
        <p>（２）コンピューター、通信回線等が事故により停止した場合</p>
        <p>（３）地震、落雷、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</p>
        <p>（４）外部サービスプロバイダーその他の本サービスの提供に必要なサービスを提供している第三者の事情により本サービスを提供できなくなった場合</p>
        <p>（５）その他、当社が緊急の停止または中断を必要と判断した場合</p>
        <p>２　当社は、以下のいずれかに該当する場合には、当社ウェブサイト上で事前告知のうえ、本サービスの全部または一部の提供を停止または中断することができるものとします。</p>
        <p>（１）本サービスに係るコンピューター・システムまたは本ソフトウェアの点検または保守作業を行う必要がある場合</p>
        <p>（２）本サービスの改善、改修等のため必要がある場合</p>
        <p>（３）その他、当社が停止または中断を必要と判断した場合</p>
        <p>３　当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。</p>
        
        <h3>第１９条（登録抹消等）</h3>
        <p>１　当社は、ユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知または催告することなく、本サービスに係るコンピューター・システム上のユーザーのデータ記憶領域に保存されたデータを削除しもしくはユーザーについて本サービスの利用を一時的に停止し、またはユーザーとしての登録を抹消、もしくは本サービス利用契約を解除することができます。</p>
        <p>（１）本規約のいずれかの条項に違反した場合</p>
        <p>（２）登録情報に虚偽の事実があることが判明した場合</p>
        <p>（３）支払停止もしくは支払不能となり、または破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始もしくはこれらに類する手続の開始の申立てがあった場合</p>
        <p>（４）当社からの問い合わせその他の回答を求める連絡に対して、３０日間以上応答がない場合</p>
        <p>（５）第４条（利用登録）第６項各号に該当する場合</p>
        <p>（６）その他、当社が本サービスの利用、ユーザーとしての登録、または本サービス利用契約の継続を適当でないと判断した場合</p>
        <p>２　前項各号のいずれかの事由に該当した場合、ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。</p>
        
        <h3>第２０条（本サービスの内容の変更、終了）</h3>
        <p>１　当社は、当社の都合により、本サービスの内容を変更し、または提供を終了することができます。</p>
        <p>２　当社が本サービスの提供を終了する場合、当社はユーザーに事前に通知をし、本サービスの提供終了時点以降の本サービスの利用の対価として利用料金が既に支払われている場合には、遅滞なくその返還を行います。</p>
        <p>３　当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。</p>
        
        <h3>第２１条（本契約の終了）</h3>
        <p>１　ユーザーは、別途当社の定める手続にしたがって当社に対して当社に対して通知をすることで本サービスの利用を終了することができます。但し、一定の期間の加入を定めるプラン等加入した場合には当該期間の終了まで解約はできません。</p>
        <p>２　本サービス利用契約は、前項本文の通知が当社に到達したとき（但書に該当するときはかかる一定の期間が経過したとき）、本サービス利用契約に基づき当社がユーザーの利用登録を抹消しとき、本サービス利用契約を解除したとき又は当社が本サービスを終了したときのいずれか早いときに終了するものとします。</p>
        
        <h3>第２２条（契約終了後のデータの取り扱い）</h3>
        <p>１　理由の如何を問わず、本サービス利用契約が終了した場合、当社は、本サービスに係るコンピューター・システム上のユーザーのデータ記憶領域に保存されたデータを消去することができるものとします。なお、当社はかかるデータ消去の義務を負わないものとします。</p>
        <p>２　当社は、前項のデータの消去につき、一切の責任を負わないものとします。</p>
        
        <h3>第２３条（秘密保持）</h3>
        <p>ユーザーは、本サービスに関連して当社がユーザーに対して秘密に取り扱うことを求めて開示した非公知の情報について、当社の事前の書面による承諾がある場合を除き、秘密に取り扱うものとします。</p>
        
        <h3>第２４条（個人情報）</h3>
        <p>１　当社は、本サービスの提供に関連して知り得たユーザーの個人情報（個人情報の保護に関する法律に定める個人情報をいうものとします。）を、別途当社が定めるプライバシーポリシーに従って取り扱います。</p>
        <p>２　当社は、特定電気通信役務提供者の損害賠償責任の制限および発信者情報の開示に関する法律に定める開示請求その他法令に基づく請求がある場合、当該請求の範囲内で情報を開示することがあります。</p>
        <p>３　当社は、ユーザーの個人情報を本サービスの提供のために必要な範囲で委託先等に提供する場合があります。</p>
        
        <h3>第２５条（保証の否認および免責）</h3>
        <p>１　当社は、本サービス（本ソフトウェアを含みます。以下同じ。）がユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、ユーザーによる本サービスの利用がユーザーに適用のある法令または業界団体の内部規則等に適合すること、および不具合を生じないことについて、何ら保証することはありません。</p>
        <p>２　当社は、当社による本サービスの提供の中断、停止、終了、利用不能または変更、ユーザーが本サービスに送信したメッセージまたは情報の削除または消失、ユーザーの登録の抹消、本サービスの利用によるユーザーのデータの消失または機器の故障もしくは損傷、その他本サービスに関してユーザーが被った損害（以下、「ユーザー損害」といいます。）につき、賠償する責任を一切負わないものとします。</p>
        <p>３　何らかの理由により当社が責任を負う場合であっても、当社は、ユーザー損害につき、損害の原因となった障害が発生した期間（但し、最終的なユーザー損害が生じてから起算して３ヶ月間を超えない期間）にユーザーが当社に支払った月額利用料の合計金額を超えて賠償する責任を負わないものとし、また、付随的損害、間接損害、特別損害、将来の損害および逸失利益にかかる損害については賠償する責任を負わないものとします。</p>
        <p>４　本サービスまたは当社ウェブサイトに関連してユーザーと他のユーザーまたは第三者との間において生じた取引、連絡、紛争等については、当社は一切責任を負いません。</p>
        <p>５　前各項にかかわらず、本サービスに関する当社とユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となり、同法が適用される場合、前各項の免責規定は適用されず、当社は、当社の過失（重過失を除きます。以下、当項において同じ。）による債務不履行または不法行為によりユーザーに生じた損害につき賠償するものとします。</p>
        <p>但し、当社は、特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し、または予見し得た場合を含みます。）については一切の責任を負わず、当社の過失による債務不履行または不法行為によりユーザーに生じた損害の賠償は以下に定める金額を上限とします。</p>
        <p>（１）有償で提供される本サービスに起因してユーザーに生じた損害については、当社が当該ユーザーから当該損害が発生した期間（但し３ヶ月間を上限とします。）に受領した利用料の額。</p>
        <p>（２）無償で提供される本サービスに起因してユーザーに生じた損害については、当該ユーザーが当該本サービスの利用に際して当該損害が発生した月に費消した回線費用の額または５００円のうち低い金額。</p>
        
        <h3>第２６条（当社に対する補償）</h3>
        <p>ユーザーは、ユーザーが法令または本サービス利用契約に違反して本サービスを利用したことに起因して（かかる趣旨のクレームを第三者より当社が受けた場合を含みます。）、当社が直接的もしくは間接的に何らかの損害、損失または費用負担（弁護士費用の負担を含みます。）を被った場合、当社の請求にしたがって直ちにこれを賠償または補償しなければなりません。</p>
        
        <h3>第２７条（譲渡禁止等）</h3>
        <p>１　当社およびユーザーは、相手方の書面による事前の承諾なく、本サービス利用契約上の地位または本サービス利用契約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</p>
        <p>２　前項にかかわらず、当社は、本サービスにかかる事業を譲渡した場合には、当該事業譲渡に伴い本サービス利用契約上の地位、本サービス利用契約に基づく権利および義務ならびにユーザーの登録情報その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーはかかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他の事業が移転するあらゆる場合を含むものとします。</p>
        
        <h3>第２８条（本規約等の変更）</h3>
        <p>当社は、本規約を含む本サービス利用契約を変更できるものとします。当社は、本サービス利用契約を変更した場合には、ユーザーに当該変更内容を当社が定める方法で通知するものとし、当該変更内容の通知後、ユーザーが本サービスを利用した場合には、ユーザーは、本規約の変更に同意したものとみなされます。</p>
        
        <h3>第２９条（委託）</h3>
        <p>当社は、当社の責任において、本サービスの提供のために必要となる業務の全部または一部につき第三者に委託できるものとします。</p>
        
        <h3>第３０条（完全合意）</h3>
        <p>本サービス利用契約は、本サービスに関連する両当事者の完全なる合意を構成し、本サービス利用契約の締結以前に両当事者間でなされた本サービスに関連する口頭または書面によるいかなる合意も、全て本サービス利用契約に取って代わられるものとする。</p>
        
        <h3>第３１条（残存条項）</h3>
        <p>本契約中、第３条（本サービスの内容・免責）第２項、第７条（ホストの責任）第１項第６項、第７項、第８項および第９項尚書き、第９条（通知・連絡）、第１２条（パスワードおよびユーザーＩＤの管理）、第１３条（利用料金および支払方法）第２項、第１５条（知的財産権・権利帰属）、第１６条（バックアップ等）、第１７条（データの消去）、第１８条（本サービスの停止）第３項、第１９条（登録抹消等）第２項、第２０条（本サービスの内容の変更、終了）第２項および第３項、第２２条（契約終了後のデータの取り扱い）、第２３条（秘密保持）、第２４条（個人情報）、第２５条（保証の否認および免責）、第２６条（当社に対する補償）、第３０条（完全合意）ならびに第３２条（準拠法および管轄裁判所）の各規定は、本契約終了後もその効力を維持するものとします。</p>
        
        <h3>第３２条（準拠法および管轄裁判所）</h3>
        <p>１　本サービス利用契約の準拠法は日本法とします。</p>
        <p>２　本サービス利用契約に起因し、または関連する一切の紛争については、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>
{/*         
        <p>本利用規約（以下、「本規約」といいます。）には、本サービスの提供条件および当社とユーザーとの権利義務関係が定められています。本サービスの申込み・利用に際しては、本規約の全文をお読み頂いたうえで、本規約に同意頂く必要があります。</p>
        <h3>第１条（適用）</h3>
        <p>１　本規約は、本サービスの提供条件および本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。<br />
          ２　当社が当社ウェブサイト上で掲載する、または個別に通知する本サービスの仕様、利用方法、注意事項、制限事項、ガイドラインその他の本サービスの利用に関するルール（以下「利用細則」といいます。）は本規約の一部を構成するものとします。<br />
          ３　本規約の説明と、前項のルールその他の本規約外における本サービスの説明等とが異なる場合は、本規約が優先して適用されるものとします。<br />
        ４　本サービスの利用にあたり、当社にライセンスを付与している第三者から利用規約が提示される場合があり（以下「ライセンサー規約」といいます。）、ユーザーは本サービス利用契約に加えライセンサー規約についても遵守する必要があります。ライセンサー規約と本サービス利用契約が矛盾抵触する場合、ライセンサー規約が優先するものとします。</p>
        <h3>第２条（用語の定義）</h3>
        <p>本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。<br />
          （１）「当社」とは、株式会社circrew（サークルー）を意味します。<br />
          （２）「本サービス」とは、第３条（本件サービスの内容・免責）に規定する当社が「circrew」または「サークルー」の名称で提供するサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。<br />
          （３）「ユーザー」とは、第４条（ユーザー利用登録）に基づいて本サービスの利用者としての登録がなされた個人を意味します。<br />
          （４）「サークルー」とは、本サービスのマッチング機能等を利用して形成されたグループを意味します。<br />
          （５）「ホスト」とは、第５条（ホスト登録）の登録を受けたユーザーを意味します。<br />
          （６）「本サービス利用契約」とは、本規約、利用細則その他当社とユーザーの間に適用される本サービスの利用に関する契約の総体を意味します。<br />
          （７）「当社ウェブサイト」とは、そのドメインに「circrew.co.jp」を含む、当社が運営するウェブサイト（理由の如何を問わず、当社のウェブサイトのドメインまたは内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。<br />
          （８）「本ソフトウェア」とは、本サービスの利用のために、当社が提供するコンピューター用プログラム、アプリケーションプログラミングインターフェイス（ＡＰＩ）、ＡＰＩ仕様書その他の仕様書およびマニュアルその他の書面を意味します。<br />
          （９）「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）を意味します。<br />
        （10）「外部サービスプロバイダー」とは、本サービスの提供のために必要な機能等を提供元として当社ウェブサイト記載の事業者を意味します。</p>
        <h3>第３条（本サービスの内容・免責）</h3>
        <p>１　本サービスは、インターネットを介して同じ趣味・研究その他の活動をしようとする個人をマッチングし、その集まり（サークルー）の設立、管理、会費の徴収等をサポートすることを目的とするものです。<br />
        ２　当社は、一定のツールの提供等本規約上明示される場合を除きホストを含むユーザーおよびサークルーの活動に関与しません。ユーザーは、他のユーザー、ホストその他サークルーに関する問題につき自ら責任を持ち、解決する必要があることを了承のうえ、本サービスを利用するものとします。</p>
        <h3>第４条（ユーザー利用登録）</h3>
        <p>１　本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ住所、電話番号、連絡用電子メールアドレス、カード情報（有料サービスを用いる場合）その他当社の定める一定の情報（以下「登録情報」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。<br />
          ２　当社は、当社の基準に従って、前項に基づいて登録申請を行った登録希望者（以下「登録申請者」といいます。）の登録の可否を判断し、当社が登録を認める場合にはその旨を登録申請者に通知します。登録申請者のユーザーとしての登録は、当社が登録を認める旨の通知を行ったことをもって完了したものとします。<br />
          ３　前項に定める登録の完了時に、本サービス利用契約がユーザーと当社の間に成立し、ユーザーは本サービスを本サービス利用契約に従い利用することができるようになります。<br />
          ４　当社は、ユーザーが本サービスのうち有料のサービス（以下「有料サービス」といいます。）の利用を希望する場合、カード情報その他の情報を登録情報として提供することを求めることができるものとします。<br />
          ５　当社は、当社の基準に従って、前項に基づいて登録申請を行ったユーザーの有料サービスの利用の可否を判断し、利用を認める場合にはその旨をユーザーに通知します。<br />
          ６　当社は、登録申請者が以下の各号のいずれかの事由に該当する場合は、登録および再登録を拒否することがあり、またその理由について一切開示義務を負いません。</p>
          <ul>
            <li>（１）当社に提供した登録情報の全部または一部につき虚偽、誤記または記載漏れがあった場合</li>
            <li>（２）反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずるものを意味します。以下同じ。）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与を行っていると当社が判断した場合</li>
            <li>（３）登録申請者が過去当社との契約に違反した者またはその関係者であると当社が判断した場合</li>
            <li>（４）第１６条（登録抹消等）に定める措置を受けたことがある場合</li>
            <li>（５）その他、当社が登録を適当でないと判断した場合</li>
          </ul>
        <p>７　登録希望者が未成年の場合、必ず事前に法定代理人の同意を得た上で申込をするものとし、申込に際し、未成年者であることおよび法定代理人の同意を得ていることを当社に通知するものとします。</p>
        <h3>第５条（ホスト登録）</h3>
        <p>１　ホストとしてサークルーを立ち上げようとするユーザーは、第４条（ユーザー利用登録）第１項に定める情報に加え、免許証その他の身分証明書、振込先口座その他当社が定める情報を、登録情報として当社の定める方法で当社に提供することにより、当社に対し、ホストとしての登録を申請することができます。<br />
        ２　前項に定めるもののほか、ホストとしての登録手続きは、第４条（ユーザー利用登録）に準じるものとします。</p>
        <h3>第６条（サークルーアカウントの開設）</h3>
        <p>１　ホストは、別途当社が定める手続きに従って、ホスト用のアカウント（サークルーアカウント）を開設することがきます。<br />
        ２　当社は、ホストに対し、サークルーアカウントにおいて、サービスのメンバーの募集、サークルーの運営、管理、会費の徴収に必要な管理ツールを利用する非独占的かつ譲渡不能な権限を許諾するものとします。</p>
        <h3>第７条（ホストの責任）</h3>
        <p>１　ホストは、ホスト自身の責任において各サークルーを運営するものとし、サークルーアカウントおよび管理ツール等を利用してなされた一切の行為およびその結果によってユーザー（本条においてホスト以外のユーザーを指すものとします。）、第三者および当社に生じた損害について一切の責任を負うものとします。<br />
          ２　ホストは、各サークルーの運営にあたり法令を遵守するとともに、各サークルーを運営する際に必要な活動を、ホスト自身の費用と責任において行うものとします。<br />
          ３　ホストは、各サークルーを運営するにあたり、ユーザーに対し、自らがホストであることを明示的に認識させるものとします。<br />
          ４　ホストは、各サークルーの運営について、当社が指定する方法によってのみユーザーが利用できるようにするものとします。<br />
          ５　ホストは、ユーザーに対して、本サービス上で告知する活動内容を遵守して各サークルーの運営を行うものとします。<br />
          ６　ホストは、各サークルーアカウントを運営するにあたり、ユーザーを含む第三者から問い合わせ、クレーム、請求、警告、提訴等（以下「問い合わせ等」といいます。）を受けた場合には、ホスト自身の費用と責任において当該問い合わせ等に対応しなければならないものとし、当社が一切の損失、損害を負担しないよう全て補償することに同意します。また、ホストは、問い合わせ等の内容が、管理ツールの利用または各サークルーアカウントの運営等に関連し、第三者の権利を侵害していることを理由とする場合には、自らの費用および責任においてこれに対応するとともに、速やかに当社に通知するものとします。<br />
          ７　当社は、ホストによる各サークルーアカウントの運営に関してユーザーまたは第三者から問い合わせ等を受けた場合には、当該問い合わせ等を行った第三者に対し、当該ホストに連絡するよう要求することができるものとします。この場合、当社は、当該ホストの連絡先を、当該問い合わせ等を行った第三者に開示できるものとし、ホストはあらかじめこれを承諾します。<br />
          ８　当社が問い合わせ等を受けたことに起因または関連して当社に損害が生じた場合には、ホストは、当該損害を全て賠償する責を負うものとします。<br />
        ９　ホストは、管理ツールまたはサークルーアカウントを利用してユーザーに対して会費その他の金員の徴収等を行う場合、当社に対し、別途当社が定める一定の手数料を支払うものとします。なお、理由のいかんを問わず本規約条明示的に定められている場合を除き、手数料の返還は行われません。</p>
        <h3>第８条（登録情報の変更）</h3>
        <p>ユーザーは、登録情報に変更があった場合、当社の定める方法により当該変更を速やかに当社に通知するものとします。</p>
        <h3>第９条（通知・連絡）</h3>
        <p>１　当社からユーザーへの通知は、当社ウェブサイトへの掲載、電子メール、書面その他当社が適当と判断する方法により行います。<br />
          ２　当社からユーザーへの通知を当社ウェブサイトへの掲載により行う場合は掲載がなされた時点において、電子メールにより行う場合は連絡用電子メール宛に送信が行われた時点において通知がなされたと見なすものとします。<br />
          ３　ユーザーは、当社からの電子メールについて、連絡用電子メールアドレスに確実に到達するようにし、当社から依頼があった場合には、当社からの電子メールに対して速やかに応答するものとします。<br />
          ４　第１項の通知を書面で行う場合は、登録情報として当社に情報が提供されたユーザーの住所宛に行うものとし、書面が到達した時点において通知がなされたものとします。但し、通知が延着または不到達となった場合は、通常到達すべきときをもって通知が到達したものと見なすものとします。<br />
        ５　本サービスに関する問い合わせその他ユーザーから当社に対する連絡または通知は、当社が別途定める方法で行うものとします。</p>
        <h3>第１０条（利用環境等）</h3>
        <p>１　ユーザーは、本サービスを利用するために必要な環境（以下「利用環境」といいます。）として当社が指定する環境（本ソフトウェアに含まれるコンピューター用ソフトウェアおよびこれらを利用できるインターネットにブロードバンドで接続が可能なＰＣ・スマート端末を含みますがこれに限られません。）を自らの費用負担と責任で用意するものとします。<br />
          ２　ユーザーは、本サービスを利用するＰＣ、スマート端末等がコンピューター・ウイルス、マルウェア等に感染しないようセキュリティソフトのインストール等適切な対策を施すものとし、感染を確認した場合は直ちに当社に連絡をするとともにこれを除去するものとし、併せて当社において適切な対策を取るために、当社が要請する情報を提供するなど協力を行うものとします。<br />
          ３　当社は、ユーザーに対し、本サービスを利用するために利用環境の変更を指定することができるものとし、ユーザーは、当社からかかる利用環境の変更の通知を受けた場合には、当該通知に定める期限までに、当該通知に定められた利用環境の変更を自らの費用負担と責任で行うものとします。<br />
        ４　当社および当社の指定する第三者は、当社が本サービスに関して保守、運用上または技術上必要であると判断した場合、ユーザーが本サービスにおいて、記録、送信等するデータ等について、監視、分析、調査等必要な行為を行うことができるものとします。</p>
        <h3>第１１条（ソフトウェアライセンスとアップデート）</h3>
        <p>１　当社は、当社が本サービスの提供に必要と判断した場合、ユーザーに対し、別途当社が定める条件で、本サービスの利用を目的として本ソフトウェアを使用するための、限定的、非独占的、譲渡禁止、無効化可能なライセンスを付与します。なお、ユーザーは、本ソフトウェアの解析またはデコンパイルをしてはならず、また、当該行為を試みること、第三者が当該行為をなすことに関与してはなりません。<br />
        ２　当社は、適宜本ソフトウェアのアップデートを行うことがあります。また、当社はユーザーのＰＣ・スマート端末上の本ソフトウェアを自動的にアップデートすることができるものとします。</p>
        <h3>第１２条（パスワードおよびユーザーＩＤの管理）</h3>
        <p>１　ユーザーは、自己の責任において、本サービスに関するパスワードおよびユーザーＩＤを適切に管理および保管するものとし、これを第三者（ユーザーに付与されるパスワードおよびユーザーＩＤについては当該ユーザー以外の者を「第三者」とします。）に利用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。<br />
        ２　パスワードまたはユーザーＩＤの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任はユーザーが負うものとし、当社は一切の責任を負いません。</p>
        <h3>第１３条（利用料金および支払方法）</h3>
        <p>１　ユーザーは、本サービスの利用の対価として、別途当社が定める利用料金を、当社が指定する方法により当社に支払うものとします。<br />
          ２　ユーザーが利用料金の支払を遅滞した場合、ユーザーは１年を３６５日として年１４．６％の割合による遅延損害金を当社に支払うものとします。<br />
        ３　当社は、１ヶ月以上の予告期間を設けた通知により第１項の利用料金を変更することができるものとします。変更後の利用料金は当該通知に特に定められている場合を除き、予告期間の満了日の属する月の翌月より適用されるものとします。</p>
        <h3>第１４条（禁止事項）</h3>
        <p>ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。<br />
          （１）本ソフトウェアの複製、解析およびデコンパイルまたは第三者によるこれらの行為への関与<br />
          （２）本サービスを通じ、以下に該当しまたは該当すると当社が判断する情報を当社または他の利用者に送信すること<br />
          ・コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報<br />
          ・当社、本サービスの他の利用者またはその他の第三者のプライバシー、名誉または信用その他法的な利益を毀損する表現を含む情報<br />
          ・反社会的な表現や他人に不快感を与える表現を含む情報<br />
          ・チェーンメール等の第三者への情報の拡散を求める情報<br />
          （３）当社、外部サービスプロバイダーその他の第三者のネットワークまたはシステム等に不正にアクセスし、または不正なアクセスを試みる行為<br />
          （４）当社、外部サービスプロバイダー、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシー、名誉、その他の権利または利益を侵害する行為<br />
          （５）本サービスのネットワークまたはシステム等に過度な負担をかける行為<br />
          （６）本サービスの運営を妨害するおそれのある行為<br />
          （７）本サービスの他の利用者のＩＤまたはパスワードを利用する行為<br />
          （８）第三者になります行為<br />
          （９）本サービスの他の利用者の情報の収集<br />
          （10）当社、外部サービスプロバイダー、本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為<br />
          （11）当社ウェブサイト上で掲載する本サービス利用に関するルールに抵触する行為<br />
          （12）公序良俗に反する行為<br />
          （13）法令に違反する行為または犯罪に関連する行為<br />
          （14）反社会勢力への利益供与<br />
          （15）前各号の行為を直接または間接に惹起し、または容易にする行為<br />
          （16）ライセンサー規約、外部サービスプロバイダーの適正利用規約その他の外部サービスプロバイダーが定める規約に違反する行為<br />
        （17）その他、当社が不適切と判断する行為</p>
        <h3>第１５条（知的財産権・権利帰属）</h3>
        <p>１　当社ウェブサイトおよび本サービスに関する知的財産権は全て当社、外部サービスプロバイダーまたは当社にライセンスを付与している者に帰属しており、本規約に基づく本サービスの利用許諾は、当社ウェブサイトまたは本サービスに関する当社、外部サービスプロバイダーまたは当社にライセンスを付与している者の知的財産権の使用許諾を意味するものではありません。<br />
        ２　当社はユーザーからのいかなるフィードバック、要望および提案について、ユーザーの許可無く使用する権限を有します。</p>
        <h3>第１６条（バックアップ等）</h3>
        <p>１　ユーザーは、本サービスに係るコンピューター・システム上に保存したデータ（他のユーザーを含む第三者からユーザーに対して送信等されたデータを含むものとし、以下同様とします。）について、自らの責任でバックアップを行うものとし、当社はデータのバックアップ、保管、保存等に関して、一切の責任を負わないものとします。<br />
        ２　当社は、本サービスに係るコンピューター・システムまたは本ソフトウェアの点検または保守作業上の必要性等の理由等により、前項のデータを一時的にバックアップする場合があります。なお、かかるバックアップはユーザーの利用のためにデータの保全を行うことを目的とするものではなく、当社はユーザーからバックアップされたデータの提供を求められた場合にこれに応じる義務はなく、またこれに応じる場合でも当社は当該データの正確性、完全性、有用性等につき保証しないものとします。</p>
        <h3>第１７条（データの消去）</h3>
        <p>１　本サービスに係るコンピューター・システム上のユーザーのデータ記憶領域に保存されたデータ容量が、当社が別途定める一定の容量を超えた場合、当社はユーザーに事前に通知することなく、容量を超えたデータを消去し、または送受信等を停止することができるものとします。<br />
        ２　当社は、前項のデータの消去または送受信等の停止につき、一切の責任を負わないものとします。</p>
        <h3>第１８条（本サービスの停止）</h3>
        <p>１　当社は、以下のいずれかに該当する場合には、事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。<br />
          （１）本サービスに係るコンピューター・システムまたは本ソフトウェアの点検または保守作業を緊急に行う必要がある場合<br />
          （２）コンピューター、通信回線等が事故により停止した場合<br />
          （３）地震、落雷、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合<br />
          （４）外部サービスプロバイダーその他の本サービスの提供に必要なサービスを提供している第三者の事情により本サービスを提供できなくなった場合<br />
          （５）その他、当社が緊急の停止または中断を必要と判断した場合<br />
          ２　当社は、以下のいずれかに該当する場合には、当社ウェブサイト上で事前告知のうえ、本サービスの全部または一部の提供を停止または中断することができるものとします。<br />
          （１）本サービスに係るコンピューター・システムまたは本ソフトウェアの点検または保守作業を行う必要がある場合<br />
          （２）本サービスの改善、改修等のため必要がある場合<br />
          （３）その他、当社が停止または中断を必要と判断した場合<br />
        ３　当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。</p>
        <h3>第１９条（登録抹消等）</h3>
        <p>１　当社は、ユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知または催告することなく、本サービスに係るコンピューター・システム上のユーザーのデータ記憶領域に保存されたデータを削除しもしくはユーザーについて本サービスの利用を一時的に停止し、またはユーザーとしての登録を抹消、もしくは本サービス利用契約を解除することができます。<br />
          （１）本規約のいずれかの条項に違反した場合<br />
          （２）登録情報に虚偽の事実があることが判明した場合<br />
          （３）支払停止もしくは支払不能となり、または破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始もしくはこれらに類する手続の開始の申立てがあった場合<br />
          （４）当社からの問い合わせその他の回答を求める連絡に対して、３０日間以上応答がない場合<br />
          （５）第４条（利用登録）第６項各号に該当する場合<br />
          （６）その他、当社が本サービスの利用、ユーザーとしての登録、または本サービス利用契約の継続を適当でないと判断した場合<br />
        ２　前項各号のいずれかの事由に該当した場合、ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。</p>
        <h3>第２０条（本サービスの内容の変更、終了）</h3>
        <p>１　当社は、当社の都合により、本サービスの内容を変更し、または提供を終了することができます。<br />
          ２　当社が本サービスの提供を終了する場合、当社はユーザーに事前に通知をし、本サービスの提供終了時点以降の本サービスの利用の対価として利用料金が既に支払われている場合には、遅滞なくその返還を行います。<br />
        ３　当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。</p>
        <h3>第２１条（本契約の終了）</h3>
        <p>１　ユーザーは、別途当社の定める手続にしたがって当社に対して当社に対して通知をすることで本サービスの利用を終了することができます。但し、一定の期間の加入を定めるプラン等加入した場合には当該期間の終了まで解約はできません。<br />
        ２　本サービス利用契約は、前項本文の通知が当社に到達したとき（但書に該当するときはかかる一定の期間が経過したとき）、本サービス利用契約に基づき当社がユーザーの利用登録を抹消しとき、本サービス利用契約を解除したとき又は当社が本サービスを終了したときのいずれか早いときに終了するものとします。</p>
        <h3>第２２条（契約終了後のデータの取り扱い）</h3>
        <p>１　理由の如何を問わず、本サービス利用契約が終了した場合、当社は、本サービスに係るコンピューター・システム上のユーザーのデータ記憶領域に保存されたデータを消去することができるものとします。なお、当社はかかるデータ消去の義務を負わないものとします。<br />
        ２　当社は、前項のデータの消去につき、一切の責任を負わないものとします。</p>
        <h3>第２３条（秘密保持）</h3>
        <p>ユーザーは、本サービスに関連して当社がユーザーに対して秘密に取り扱うことを求めて開示した非公知の情報について、当社の事前の書面による承諾がある場合を除き、秘密に取り扱うものとします。</p>
        <h3>第２４条（個人情報）</h3>
        <p>１　当社は、本サービスの提供に関連して知り得たユーザーの個人情報（個人情報の保護に関する法律に定める個人情報をいうものとします。）を、別途当社が定めるプライバシーポリシーに従って取り扱います。<br />
          ２　当社は、特定電気通信役務提供者の損害賠償責任の制限および発信者情報の開示に関する法律に定める開示請求その他法令に基づく請求がある場合、当該請求の範囲内で情報を開示することがあります。<br />
        ３　当社は、ユーザーの個人情報を本サービスの提供のために必要な範囲で委託先等に提供する場合があります。</p>
        <h3>第２５条（保証の否認および免責）</h3>
        <p>１　当社は、本サービス（本ソフトウェアを含みます。以下同じ。）がユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、ユーザーによる本サービスの利用がユーザーに適用のある法令または業界団体の内部規則等に適合すること、および不具合を生じないことについて、何ら保証することはありません。<br />
          ２　当社は、当社による本サービスの提供の中断、停止、終了、利用不能または変更、ユーザーが本サービスに送信したメッセージまたは情報の削除または消失、ユーザーの登録の抹消、本サービスの利用によるユーザーのデータの消失または機器の故障もしくは損傷、その他本サービスに関してユーザーが被った損害（以下、「ユーザー損害」といいます。）につき、賠償する責任を一切負わないものとします。<br />
          ３　何らかの理由により当社が責任を負う場合であっても、当社は、ユーザー損害につき、損害の原因となった障害が発生した期間（但し、最終的なユーザー損害が生じてから起算して３ヶ月間を超えない期間）にユーザーが当社に支払った月額利用料の合計金額を超えて賠償する責任を負わないものとし、また、付随的損害、間接損害、特別損害、将来の損害および逸失利益にかかる損害については賠償する責任を負わないものとします。<br />
          ４　本サービスまたは当社ウェブサイトに関連してユーザーと他のユーザーまたは第三者との間において生じた取引、連絡、紛争等については、当社は一切責任を負いません。<br />
          ５　前各項にかかわらず、本サービスに関する当社とユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となり、同法が適用される場合、前各項の免責規定は適用されず、当社は、当社の過失（重過失を除きます。以下、当項において同じ。）による債務不履行または不法行為によりユーザーに生じた損害につき賠償するものとします。<br />
          但し、当社は、特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し、または予見し得た場合を含みます。）については一切の責任を負わず、当社の過失による債務不履行または不法行為によりユーザーに生じた損害の賠償は以下に定める金額を上限とします。<br />
          （１）有償で提供される本サービスに起因してユーザーに生じた損害については、当社が当該ユーザーから当該損害が発生した期間（但し３ヶ月間を上限とします。）に受領した利用料の額。<br />
        （２）無償で提供される本サービスに起因してユーザーに生じた損害については、当該ユーザーが当該本サービスの利用に際して当該損害が発生した月に費消した回線費用の額または５００円のうち低い金額。</p>
        <h3>第２６条（当社に対する補償）</h3>
        <p>ユーザーは、ユーザーが法令または本サービス利用契約に違反して本サービスを利用したことに起因して（かかる趣旨のクレームを第三者より当社が受けた場合を含みます。）、当社が直接的もしくは間接的に何らかの損害、損失または費用負担（弁護士費用の負担を含みます。）を被った場合、当社の請求にしたがって直ちにこれを賠償または補償しなければなりません。</p>
        <h3>第２７条（譲渡禁止等）</h3>
        <p>１　当社およびユーザーは、相手方の書面による事前の承諾なく、本サービス利用契約上の地位または本サービス利用契約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。<br />
        ２　前項にかかわらず、当社は、本サービスにかかる事業を譲渡した場合には、当該事業譲渡に伴い本サービス利用契約上の地位、本サービス利用契約に基づく権利および義務ならびにユーザーの登録情報その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーはかかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他の事業が移転するあらゆる場合を含むものとします。</p>
        <h3>第２８条（本規約等の変更）</h3>
        <p>当社は、本規約を含む本サービス利用契約を変更できるものとします。当社は、本サービス利用契約を変更した場合には、ユーザーに当該変更内容を当社が定める方法で通知するものとし、当該変更内容の通知後、ユーザーが本サービスを利用した場合には、ユーザーは、本規約の変更に同意したものとみなされます。</p>
        <h3>第２９条（委託）</h3>
        <p>当社は、当社の責任において、本サービスの提供のために必要となる業務の全部または一部につき第三者に委託できるものとします。</p>
        <h3>第３０条（完全合意）</h3>
        <p>本サービス利用契約は、本サービスに関連する両当事者の完全なる合意を構成し、本サービス利用契約の締結以前に両当事者間でなされた本サービスに関連する口頭または書面によるいかなる合意も、全て本サービス利用契約に取って代わられるものとする。</p>
        <h3>第３１条（残存条項）</h3>
        <p>本契約中、第３条（本サービスの内容・免責）第２項、第７条（ホストの責任）第１項第６項、第７項、第８項および第９項尚書き、第９条（通知・連絡）、第１２条（パスワードおよびユーザーＩＤの管理）、第１３条（利用料金および支払方法）第２項、第１５条（知的財産権・権利帰属）、第１６条（バックアップ等）、第１７条（データの消去）、第１８条（本サービスの停止）第３項、第１９条（登録抹消等）第２項、第２０条（本サービスの内容の変更、終了）第２項および第３項、第２２条（契約終了後のデータの取り扱い）、第２３条（秘密保持）、第２４条（個人情報）、第２５条（保証の否認および免責）、第２６条（当社に対する補償）、第３０条（完全合意）ならびに第３２条（準拠法および管轄裁判所）の各規定は、本契約終了後もその効力を維持するものとします。</p>
        <h3>第３２条（準拠法および管轄裁判所）</h3>
        <p>１　本サービス利用契約の準拠法は日本法とします。
        ２　本サービス利用契約に起因し、または関連する一切の紛争については、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</p> */}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/StaticPages/Terms/TermsBody.jsx